import axios from "axios";

const customerOptions = [];
const platOptions = [];
const produitOptions = [];
const tableOptions = [];

export const FournisseurForm = [
    {
        label: "Nom de la compagnie",
        name: "nomcompagnie",
        componentType: "input",
        type: "text",
        placeholder: "Entrez le nom de la compagnie",
    },
    {
        label: "Téléphone",
        name: "telephone",
        componentType: "input",
        type: "text",
        placeholder: "Entrez le numéro de téléphone",
    },
    {
        label: "Email",
        name: "email",
        componentType: "input",
        type: "email",
        placeholder: "Entrez l'email",
    },
    {
        label: "Adresse",
        name: "adresse",
        componentType: "input",
        type: "text",
        placeholder: "Entrez l'adresse",
    },
    {
        label: "Ville",
        name: "ville",
        componentType: "input",
        type: "text",
        placeholder: "Entrez la ville",
    },
    {
        label: "Pays",
        name: "pays",
        componentType: "input",
        type: "text",
        placeholder: "Entrez le pays",
    },
];
export const FournisseurEditForm = [
    {
        label: "Nom de la compagnie",
        name: "nomcompagnie",
        componentType: "input",
        type: "text",
        placeholder: "Entrez le nom de la compagnie",
    },
    {
        label: "Téléphone",
        name: "telephone",
        componentType: "input",
        type: "text",
        placeholder: "Entrez le numéro de téléphone",
    },
    {
        label: "Email",
        name: "email",
        componentType: "input",
        type: "email",
        placeholder: "Entrez l'email",
    },
    {
        label: "Adresse",
        name: "adresse",
        componentType: "input",
        type: "text",
        placeholder: "Entrez l'adresse",
    },
    {
        label: "Ville",
        name: "ville",
        componentType: "input",
        type: "text",
        placeholder: "Entrez la ville",
    },
    {
        label: "Pays",
        name: "pays",
        componentType: "input",
        type: "text",
        placeholder: "Entrez le pays",
    },
    {
        label: "Désactivé",
        name: "disable",
        componentType: "input",
        type: "checkbox",
        labelText: "Désactiver cet élément",
    },
    {
        label: "Note sur le fournisseur",
        name: "notes",
        componentType: "textarea",
        placeholder: "Merci de saisir une note sur le fournisseur",
    },
];


export const AdresseForm = [
    {
        label: "Adresse",
        name: "adress",
        componentType: "input",
        type: "text",
        placeholder: "Entrez l'adresse",
    },
    {
        label: "Téléphone",
        name: "phone",
        componentType: "input",
        type: "text",
        placeholder: "Entrez le téléphone",
    },
    {
        label: "Ville",
        name: "ville",
        componentType: "input",
        type: "text",
        placeholder: "Entrez la ville",
    },
    {
        label: "Client",
        name: "customerid",
        componentType: "select",
        options: customerOptions,
    },
];


export const CategorieForm = [
    {
        label: "Désignation",
        name: "designation",
        componentType: "input",
        type: "text",
        placeholder: "Entrez la désignation",
    },
    {
        label: "Description",
        name: "description",
        componentType: "textarea",
        placeholder: "Entrez une description",
    },
];
export const CategorieEditForm = [
    {
        label: "Désignation",
        name: "designation",
        componentType: "input",
        type: "text",
        placeholder: "Entrez la désignation",
    },
    {
        label: "Description",
        name: "description",
        componentType: "textarea",
        placeholder: "Entrez une description",
    },
    {
        label: "Désactivé",
        name: "disable",
        componentType: "input",
        type: "checkbox",
        labelText: "Désactiver cet élément",
    },
];

export const PlatForm = [
    {
        label: "Désignation",
        name: "designation",
        componentType: "input",
        type: "text",
        placeholder: "Entrez le nom du plat",
    },
    {
        label: "Nombre de Portion",
        name: "nbPortion",
        componentType: "input",
        type: "number",
        placeholder: "Entrez le nombre de portions",
    },
    {
        label: "Quantité seuil d'alerte",
        name: "alertPortion",
        componentType: "input",
        type: "number",
        placeholder: "Entrez la quantité seuil d'alerte",
    },
    {
        label: "Prix de Vente",
        name: "prixVente",
        componentType: "input",
        type: "number",
        placeholder: "Entrez le prix de vente",
    },    
    {
        label: "Pourcentage Invendu",
        name: "pourcentageInvendu",
        componentType: "input",
        type: "number",
        placeholder: "Entrez le pourcentage d'invendu",
    }, 
    {
        label: "Temps Préparation",
        name: "tempsPrepa",
        componentType: "input",
        type: "time",
        placeholder: "Entrez le temps de préparation",
    },   
    {
        label: "Charge de TVA",
        name: "tauxTVA",
        componentType: "input",
        type: "number",
        placeholder: "Entrez le taux TVA",
    },
    {
        label: "Photos du plat",
        name: "photo",
        componentType: "file",
        type: "file",
        placeholder: "Choisissez une photo",
    },
       
];


export const LgProduitPlatForm = [
    {
        label: "Produit",
        name: "ProduitId",
        componentType: "select",
        options: produitOptions,
    },
    {
        label: "Unité Nécessaire",
        name: "uniteNecessaire",
        componentType: "input",
        type: "number",
        placeholder: "Entrez l'unité nécessaire",
    },
    {
        label: "Prix de Revient",
        name: "prixRevient",
        componentType: "input",
        type: "number",
        placeholder: "Entrez le prix de revient",
    },
    {
        label: "Plat",
        name: "PlatId",
        componentType: "select",
        options: platOptions,
    },
    {
        label: "Désactivé",
        name: "disable",
        componentType: "checkbox",
        labelText: "Désactiver cet élément",
    },
];


export const ProduitAddForm = [
    {
        label: "Désignation",
        name: "designation",
        componentType: "input",
        type: "text",
        placeholder: "Entrez la désignation du produit",
    },
    {
        label: "Photos du produit",
        name: "photo",
        componentType: "file",
        type: "file",
        placeholder: "Choisissez une photo",
    },
    {
        label: "Unité",
        name: "unite",
        componentType: "input",
        type: "text",
        placeholder: "Entrez l'unité du produit",
    },
    {
        label: "Quantité entrée en stock",
        name: "entreStock",
        componentType: "input",
        type: "number",
        placeholder: "Saisir la quantité entrée en stock",
    },
    {
        label: "Prix d'achat",
        name: "prix",
        componentType: "input",
        type: "number",
        placeholder: "Saisir le prix d'achat",
    },
    {
        label: "Pourcentage Invendu",
        name: "pcInvendu",
        componentType: "input",
        type: "number",
        placeholder: "Saisir le pourcentage d'invendu",
    }, 
    {
        label: "Charge de TVA",
        name: "tauxTVA",
        componentType: "input",
        type: "number",
        placeholder: "Entrez le taux TVA",
    },
    {
        label: "Quantité seuil d'alerte",
        name: "alertstockqty",
        componentType: "input",
        type: "number",
        placeholder: "Entrez la quantité seuil d'alerte",
    },
];


export const ProduitEditForm = [
    {
        label: "Désignation",
        name: "designation",
        componentType: "input",
        type: "text",
        placeholder: "Entrez la désignation du produit",
    },
    {
        label: "Photos du produit",
        name: "photo",
        componentType: "file",
        type: "file",
        placeholder: "Choisissez une photo",
    },
    {
        label: "Unité",
        name: "unite",
        componentType: "input",
        type: "text",
        placeholder: "Entrez l'unité du produit",
    },
    {
        label: "Prix d'achat",
        name: "prix",
        componentType: "input",
        type: "number",
        placeholder: "Saisir le prix d'achat",
    },
    {
        label: "Quantité entrée en stock",
        name: "entreStock",
        componentType: "input",
        type: "number",
        placeholder: "Saisir la quantité entrée en stock",
    },
    
    {
        label: "Pourcentage Invendu",
        name: "pcInvendu",
        componentType: "input",
        type: "number",
        placeholder: "Saisir le pourcentage d'invendu",
    }, 
    {
        label: "Charge de TVA",
        name: "tauxTVA",
        componentType: "input",
        type: "number",
        placeholder: "Entrez le taux TVA",
    },
    {
        label: "Désactivé",
        name: "disable",
        componentType: "input",
        type: "checkbox",
        labelText: "Désactiver cet élément",
    },
];



export const ReservationForm = [
    {
        label: "Date",
        name: "date",
        componentType: "input",
        type: "datetime-local",
        placeholder: "Entrez la date de réservation",
    },
    {
        label: "Client",
        name: "customerid",
        componentType: "select",
        options: customerOptions,
    },
    {
        label: "Table",
        name: "tableid",
        componentType: "select",
        options: tableOptions,
    },
    {
        label: "Durée (heures)",
        name: "nbHeure",
        componentType: "input",
        type: "time",
        placeholder: "Entrez la durée de la réservation",
    },
    {
        label: "Détails",
        name: "details",
        componentType: "textarea",
        placeholder: "Entrez les détails de la réservation",
    },
];


export const TableForm = [
    {
        label: "Désignation",
        name: "designation",
        componentType: "input",
        type: "text",
        placeholder: "Entrez la désignation de la table",
    },
    {
        label: "Place",
        name: "place",
        componentType: "input",
        type: "number",
        placeholder: "Entrez le nombre de places",
    },
    {
        label: "Disponible",
        name: "disponible",
        componentType: "checkbox",
    },
    {
        label: "Notes",
        name: "notes",
        componentType: "textarea",
        placeholder: "Entrez des notes sur la table",
    },
];


export const CaisseOuvertureForm = [
    {
        label: "Montant initial",
        name: "openingAmount",
        componentType: "input",
        type: "number",
        placeholder: "Entrez le montant à l'ouverture de la caisse",
    },
    {
        label: "Saisisez ton horaire de travail",
        name: "shiftId",
        componentType: "input",
        type: "input",
        placeholder: "Horaires de travail: 08:00-12:00",
    },
]
export const CaisseFermetureForm = [
    {
        label: "Montant Final",
        name: "closingAmount",
        componentType: "input",
        type: "number",
        placeholder: "Montant de la fermeture de la caisse",
    },
    {
        label: "Saisisez ton horaire de travail",
        name: "shiftId",
        componentType: "input",
        type: "input",
        placeholder: "Horaires: 08:00-12:00",
    },
    {
        label: "Votre ID de travail",
        name: "discrepancyAgentId",
        componentType: "input",
        type: "input",
        placeholder: "Saisissez votre code de travail et votre nom",
    },
    {
        label: "Explications de l'écart",
        name: "discrepancyExplanation",
        componentType: "textarea",
        type: "textarea",
        placeholder: "Fournir des explications sur l'écart de caisse",
    },
]
export const CaisseRetraitForm = [
    {
        label: "Montant Final",
        name: "closingAmount",
        componentType: "input",
        type: "number",
        placeholder: "Montant de la fermeture de la caisse",
    },   
    {
        label: "Votre ID de travail",
        name: "discrepancyAgentId",
        componentType: "input",
        type: "input",
        placeholder: "Saisissez votre code de travail et votre nom",
    },
    {
        label: "Explications de l'écart",
        name: "discrepancyExplanation",
        componentType: "textarea",
        type: "textarea",
        placeholder: "Fournir des explications sur l'écart de caisse",
    },
]

const isLocalhost = Boolean(
    window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export const API_URL = isLocalhost ? "http://localhost:5700" : "https://mezangemaapi.logiane.com";